import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastEditRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit',
)(
  createGroupBroadcastEditRoute({
    kind: 'space',
    fromId: '/_authed/groups/$id/admin/broadcasts/$broadcastId/edit',
  }),
);
